import axios from "axios";
import ajax from "../api/ajax";

export function hasHttpHyperlink(cell) {
  return cell != null &&
    cell.hyperlink != null &&
    String(cell.hyperlink).trim().toLowerCase() === "http";
}

export function isHttpHyperlink(cell) {
  if (!hasHttpHyperlink(cell) || cell.value == null) {
    return false;
  }
  const value = String(cell.value).trim();
  return /^https?:\/\//i.test(value);
}

export function openHttpHyperlink(value) {
  const url = value == null ? "" : String(value).trim();
  if (url === "") {
    return Promise.resolve();
  }

  const apiBaseUrl = ajax.ajaxUrl();
  let resolvedUrl;
  try {
    resolvedUrl = new URL(url, apiBaseUrl + "/");
  } catch (error) {
    return Promise.reject(error);
  }
  const trustedOrigins = [window.location.origin, new URL(apiBaseUrl).origin];
  const shouldUseAuthorization = trustedOrigins.indexOf(resolvedUrl.origin) >= 0 ||
    resolvedUrl.href.toLowerCase().indexOf("ecwms") >= 0;
  if (!shouldUseAuthorization) {
    window.open(resolvedUrl.href, "_blank", "noopener");
    return Promise.resolve();
  }

  const targetWindow = window.open("", "_blank");
  if (targetWindow) {
    targetWindow.opener = null;
  }

  return axios.get(resolvedUrl.href, { responseType: "blob" })
    .then(response => {
      const objectUrl = window.URL.createObjectURL(response.data);
      if (targetWindow) {
        targetWindow.location.replace(objectUrl);
      } else {
        window.open(objectUrl, "_blank");
      }
      window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
    })
    .catch(error => {
      if (targetWindow) {
        targetWindow.close();
      }
      return Promise.reject(error);
    });
}
